import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

// Service Data
const services = [
  {
    title: 'Web Dev',
    description:
      'I build modern, responsive websites using React and Tailwind, with clean and organized code. I focus on creating responsive designs that work smoothly on all devices.',
    icon: (
      <svg
        className="w-10 h-10 text-[#a98467]"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 12h18M3 6h18M3 18h18" />
      </svg>
    ),
  },
  {
    title: 'Mobile Dev',
    description:
      'I create native mobile apps with Kotlin, aiming for clean, scalable code and smooth user experiences across devices.',
    icon: (
      <svg
        className="w-10 h-10 text-[#a98467]"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="7" y="2" width="10" height="20" rx="2" ry="2" />
        <path d="M11 18h2" />
      </svg>
    ),
  },
  {
    title: 'UI/UX',
    description:
      'With a frontend mindset, I focus on layout, flow, and clarity, making sure every interaction feels natural and intuitive',
    icon: (
      <svg
        className="w-10 h-10 text-[#a98467]"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M14.31 8l5.74 9.94M9.69 8h11.48M7.38 12l5.74-9.94" />
      </svg>
    ),
  },
  {
    title: 'Software Testing',
    description:
      "I thoroughly test software to catch bugs, handle edge cases, and ensure everything runs reliably and smoothly.",
    icon: (
      <svg
        className="w-10 h-10 text-[#a98467]"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M8 12l2 2 4-4" />
      </svg>
    ),
  },
];

// Animation variants
const fadeMotion = {
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.5,
      ease: 'easeOut',
    },
  }),
  hidden: {
    opacity: 0,
    y: 30,
    transition: {
      duration: 0.5,
    },
  },
};

// Services Component
const Services = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { amount: 0.4, once: true });

  return (
    <section
      id="services"
      className="min-h-screen py-20 px-6 md:px-20 bg-[#F5F3EF] text-[#3b2f2f]"
    >
      <div className="w-full max-w-[1440px]"></div>
      <h2 className="text-2xl font-bold mb-12 text-center text-[#5e4b45]">What I Do</h2>

      <div
  ref={ref}
  className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8 max-w-6xl mx-auto items-stretch"
>
  {services.map(({ title, description, icon }, index) => (
    <motion.div
      key={title}
      custom={index}
      animate={isInView ? 'visible' : 'hidden'}
      initial="hidden"
      variants={fadeMotion}
      whileHover={{ scale: 1.03 }}
      transition={{ type: 'spring', stiffness: 300 }}
      className="bg-white/60 rounded-xl p-6 flex flex-col gap-3 shadow-md border border-[#dbcfc1] cursor-pointer flex-grow"
      style={{ minHeight: '250px' }} // Optional: set min height if you want uniform minimum size
    >
      <div className="flex items-center gap-4">
        {icon}
        <h3 className="text-lg font-semibold text-[#3b2f2f]">{title}</h3>
      </div>
      <p className="text-md pl-14 leading-relaxed text-justify text-[#5e4b45] flex-grow">
        {description}
      </p>
    </motion.div>
  ))}
</div>
    </section>
  );
};

export default Services;
